import { render, staticRenderFns } from "./ImportCard.vue?vue&type=template&id=63dd4682&scoped=true&"
import script from "./ImportCard.vue?vue&type=script&lang=js&"
export * from "./ImportCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportCard.vue?vue&type=style&index=0&id=63dd4682&prod&lang=scss&scoped=true&"
import style1 from "./ImportCard.vue?vue&type=style&index=1&id=63dd4682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd4682",
  null
  
)

export default component.exports